export const normalizeValue = (value, min, max) => parseInt(((value - min) * 100) / (max - min));

export const isJsonString = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/lib/utils.js